<script lang="ts">
  import RepositoryFactory, { CONTRACT } from '../../repositories/RepositoryFactory';
  import { loginUser } from '../../components/auth/LoginUser';
  import Loading from '../../etc/loader.svelte';

  let isConfirm = false;
  let isComplete = false;
  let isLoading: boolean = false;

  // 確認画面
  function onConfirm() {
    isConfirm = true;
    isComplete = false;
  }
  function onComplete() {
    isConfirm = false;
    isComplete = true;
  }
  function onBack() {
    isConfirm = false;
    isComplete = false;
  }
  function doPost() {
    isLoading = true;
    const contractRepository = RepositoryFactory[CONTRACT];
    contractRepository
      .requestQueBacklog({
        processCategoryCode: 'BUSINESS_CHANGE',
        changeDate: null,
        changeInfo: null,
        contactDate1: null,
        contactDate2: null,
        contactDate3: null
      })
      .then((res) => {
        isLoading = false;
        onComplete();
      })
      .catch((error) => {
        isLoading = false;
        if (error.response.status === 411) {
          alert('入力内容に誤りがあります。再度入力してください。');
        } else if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('エラーが発生しました。再度やり直してください。');
        }
      });
  }
</script>

{#if isLoading}
  <Loading />
{/if}

<div class="h-auto p-6 bg-white m-auto">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-2xl font-bold text-gray-700">事業者変更</h1>
    </div>
  </div>

  <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
    <div class="flex flex-col">
      {#if isComplete}
        <div class="flex-1 mb-4">
          <div class="inline-flex justify-items-center items-center min-w-full p-6">
            <span class="">事業者変更依頼が完了しました。</span>
          </div>
        </div>
      {:else if isConfirm}
        <div class="flex-1 mb-4">
          <div class="min-w-full">
            転用承認番号の申し込みをさせていただきます。<br />
            この時点ではお手続きは完了していません。<br />
            お送りするメールの内容を必ずご確認ください。
          </div>
        </div>
      {:else}
        <div class="flex-1 mb-4">
          <div class="min-w-full">
            後ほど、カスタマーセンターからご登録のメールアドレスへご連絡させていただきます。
            <br />
            注意事項等をご確認いただき、「手続きへ」を押してください。
          </div>
        </div>
      {/if}

      <div class="flex-1 mb-10">
        <div class="shadow rounded bg-gray-200 p-4 text-sm">
          <div>
            ※お問い合わせ状況により、ご連絡に数日お時間を要する場合があります。
            <br />
            ※お問い合わせは以下からご連絡いただきますようお願いいたします。
            <br />
            URL：
            <a href="https://bb.unext.co.jp/contact" rel="noopener noreferrer" target="_blank">
              https://bb.unext.co.jp/contact
            </a>
          </div>
        </div>
      </div>

      {#if isConfirm}
        <div class="flex-1 mt-8">
          <div class="flex flex-col justify-items-center items-center">
            <div class="flex-1">
              <button on:click|once={onBack} class="button-secondary">戻る</button>
              <button on:click|once={doPost} class="button-primary">完了</button>
            </div>
          </div>
        </div>
      {:else if !isComplete}
        <div class="flex-1">
          <div class="flex flex-col justify-items-center items-center">
            <div class="flex-1">
              <button on:click|once={onConfirm} class="button-primary">手続きへ</button>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
</div>

<style lang="postcss">
  .button-primary {
    @apply bg-green-400 rounded-lg hover:bg-green-500 focus:outline-none text-sm font-semibold text-white px-10 py-2;
  }
  .button-secondary {
    @apply bg-gray-300 rounded-lg hover:bg-gray-400 text-gray-500 focus:outline-none px-10 py-2;
  }
</style>
